import {getParams, isLoadByIframe} from '@/utils/util';
import {API_IS_ACTIVATED_NEW} from './isActivated';

// 所有认证方式submit接口
export const API_IS_FROM = {
    ...API_IS_ACTIVATED_NEW,
};

export const FROM_MAP: {
    [key: string]: string;
} = {
    baiduyunapp: 'CloudAPP',
};

export function getFromHeader() {
    const hashSeg = location.hash ? location.hash.split('?') : [];
    const search = hashSeg.length > 1 ? hashSeg[1] : '';
    let fromHeader = null;
    if (isLoadByIframe()) {
        fromHeader = 'pc-iframe';
    } else if (search) {
        const query: any = getParams(search);
        fromHeader = query?.from ? FROM_MAP?.[query?.from?.toLowerCase()] : null;
    }
    return fromHeader ? {
        'X-Bce-Qualify-Source': fromHeader,
    } : null;
}

export function getNeedFromHeader(url: string) {
    const needFrom = API_IS_FROM[url];
    if (needFrom) {
        const fromHeader = getFromHeader();
        return fromHeader;
    }
    return null;
}
